<template>
  <section class="multi-business-section">
    <div class="container multi-business-container">
      <div class="multi-business-video">
        <div class="hero__video-container">
          <VideoFrame
            :src="videoUrl"
            :config="videoConfig"
            class="hero__video"
            alt="Demonstração do produto"
          />
          <div class="hero__video-overlay"></div>
        </div>
      </div>
      <div class="multi-business-content">
        <div class="multi-business-content">
          <h1 v-html="$t('message.multiBusinessTitle')" class="title" />
          <p class="description">
            {{ $t('message.multiBusinessDescription') }}
          </p>
        </div>
        <div class="multi-business-content">
          <h1 v-html="$t('message.multiBusinessTitle2')" class="title" />
          <p class="description">
            {{ $t('message.multiBusinessDescription2') }}
          </p>
          <!-- <a
            :href="'https://financeiro.janelaunica.com.br/#/registro'"
            target="_blank"
            rel="noopener noreferrer"
            class="cta-button"
          >
            {{ $t('message.learnMore') }}
          </a> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import VideoFrame from './VideoFrame.vue'

import logoWhite from '@/assets/logo/logo-juf-financeiro-white.svg'

const { t } = useI18n()

const imgNfse = 'https://ju-financeiro-publi.s3.sa-east-1.amazonaws.com/gifs/nfse.gif'
const imgFinancasInteligente = 'https://ju-financeiro-publi.s3.sa-east-1.amazonaws.com/gifs/financas-inteligente.gif'
const imgConciliacao = 'https://ju-financeiro-publi.s3.sa-east-1.amazonaws.com/gifs/conciliacao.gif'
const imgInvoices = 'https://ju-financeiro-publi.s3.sa-east-1.amazonaws.com/gifs/invoices.gif'

const videoUrl = ref(
  'https://ju-financeiro-publi.s3.sa-east-1.amazonaws.com/videos/storie.mp4'
)

const videoConfig = computed(() => [
  // {
  //   id: 'intro-logo',
  //   content: `<img src="${logoWhite}" alt="Logo Janela Unica Financeiro" style="width: 250px;">`,
  //   start: 0.5,
  //   end: 4.1,
  //   position: { top: 35, left: 12 },
  //   transition: { type: 'fade', direction: 'top' },
  //   styleClass: 'video-welcome',
  // },
  {
    id: 'feature-title-nfse',
    content: t('message.videoNfseTitle'),
    start: 0,
    end: 5,
    position: { top: 57, left: 22 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-title',
  },
  {
    id: 'feature-text-nfse',
    content: t('message.videoNfseText'),
    start: 0.2,
    end: 5.2,
    position: { top: 70, left: 20 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-text',
  },
  {
    id: 'feature-image-nfse',
    content: `<img src="${imgNfse}" alt="Emissão simplificada de NFSe" style="width: 100px;">`,
    start: 5.4 - 5,
    end: 10.4 - 5,
    position: { top: 78, left: 35 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-image',
  },
  {
    id: 'feature-title-financas',
    content: t('message.videoFinancasTitle'),
    start: 11 - 5,
    end: 16 - 5,
    position: { top: 57, left: -1 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-title',
  },
  {
    id: 'feature-text-financas',
    content: t('message.videoFinancasText'),
    start: 11.2 - 5,
    end: 16.2 - 5,
    position: { top: 70, left: -1 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-text',
  },
  {
    id: 'feature-image-financas',
    content: `<img src="${imgFinancasInteligente}" alt="Controle avançado de Receitas e Despesas" style="width: 140px;">`,
    start: 11.4 - 5,
    end: 16.4 - 5,
    position: { top: 77, left: 10 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-image',
  },
  {
    id: 'feature-title-conciliacao',
    content: t('message.videoConciliacaoTitle'),
    start: 17 - 5,
    end: 22 - 5,
    position: { top: 57, left: 15 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-title',
  },
  {
    id: 'feature-text-conciliacao',
    content: t('message.videoConciliacaoText'),
    start: 17.2 - 5,
    end: 22.2 - 5,
    position: { top: 70, left: 15 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-text',
  },
  {
    id: 'feature-image-conciliacao',
    content: `<img src="${imgConciliacao}" alt="Conciliação bancária automatizada" style="width: 180px;">`,
    start: 17.4 - 5,
    end: 22.4 - 5,
    position: { top: 80, left: 20 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-image',
  },
  {
    id: 'feature-title-faturas',
    content: t('message.videoFaturasTitle'),
    start: 23 - 5,
    end: 28 - 5,
    position: { top: 57, left: -1 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-title',
  },
  {
    id: 'feature-text-faturas',
    content: t('message.videoFaturasText'),
    start: 23.2 - 5,
    end: 28.2 - 5,
    position: { top: 70, left: -1 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-text',
  },
  {
    id: 'feature-image-faturas',
    content: `<img src="${imgInvoices}" alt="Controle avançado de Receitas e Despesas" style="width: 140px;">`,
    start: 23.4 - 5,
    end: 28.4 - 5,
    position: { top: 77, left: 10 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-image',
  },
  {
    id: 'list-item-1',
    content: t('message.videoListItem1'),
    start: 29 - 5,
    end: 34 - 5,
    position: { top: 5, left: 5 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-list-item',
  },
  {
    id: 'list-item-2',
    content: t('message.videoListItem2'),
    start: 29.4 - 5,
    end: 34 - 5,
    position: { top: 15, left: 5 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-list-item',
  },
  {
    id: 'list-item-3',
    content: t('message.videoListItem3'),
    start: 29.8 - 5,
    end: 34 - 5,
    position: { top: 25, left: 5 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-list-item',
  },
  {
    id: 'list-item-4',
    content: t('message.videoListItem4'),
    start: 30.2 - 5,
    end: 34 - 5,
    position: { top: 35, left: 5 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-list-item',
  },
  {
    id: 'list-item-5',
    content: t('message.videoListItem5'),
    start: 30.6 - 5,
    end: 34 - 5,
    position: { top: 45, left: 5 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-list-item',
  },
  {
    id: 'list-item-6',
    content: t('message.videoListItem6'),
    start: 31 - 5,
    end: 34 - 5,
    position: { top: 55, left: 5 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-list-item',
  },
  {
    id: 'list-item-7',
    content: t('message.videoListItem7'),
    start: 31.4 - 5,
    end: 34 - 5,
    position: { top: 65, left: 5 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-list-item',
  },
  {
    id: 'list-item-8',
    content: t('message.videoListItem8'),
    start: 31.8 - 5,
    end: 34 - 5,
    position: { top: 75, left: 5 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-list-item',
  },
  {
    id: 'list-item-9',
    content: t('message.videoListItem9'),
    start: 32.2 - 5,
    end: 34 - 5,
    position: { top: 85, left: 5 },
    transition: { type: 'fade' },
    styleClass: 'video-feature-list-item',
  },
  {
    id: 'outro-logo',
    content: `<img src="${logoWhite}" alt="Logo Janela Unica Financeiro" style="width: 240px;">`,
    start: 30,
    end: 34,
    position: { top: 35, left: 9.5 },
    transition: { type: 'fade', direction: 'top' },
    styleClass: 'video-welcome',
  },
])
</script>

<style>
.multi-business-section {
  background-color: var(--c5);
  padding: 5rem 0;
}

.multi-business-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 1000px !important;
  margin: 0 auto;
  padding: 0 1.5rem;
  text-align: center;
  align-items: center;
}

.multi-business-content .title {
  font-size: 2rem;
}

.multi-business-video,
.multi-business-content {
  flex: 1;
}

.multi-business-video {
  max-width: 500px;
  display: contents !important;
}

.section-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.title {
  font-family: var(--sans-serif);
  font-weight: 700;
  line-height: 1.2;
  color: var(--c1);
  margin-bottom: 1rem;
}

.description {
  font-size: clamp(1rem, 2.5vw, 1.3rem);
  line-height: 1.6;
  color: var(--c3);
  margin-bottom: 2rem;
}

.cta-button {
  display: inline-block;
  padding: 1rem 2rem;
  border-radius: 9999px; /* Botão com bordas totalmente arredondadas */
  background-color: #386dda;
  color: #ffffff;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.cta-button:hover {
  background-color: #2c5bbd; /* Cor mais escura ao passar o mouse */
}

@media (min-width: 991px) {
  .multi-business-container {
    flex-direction: row;
    text-align: left;
    gap: 50px;
  }

  .multi-business-content {
    margin-top: 2rem;
  }

  .multi-business-content .title {
    font-size: 3rem;
  }
}

.multi-business-video {
  display: hidden;
}

.hero__video-container {
  position: relative;
  width: 100%;
  max-width: 380px;
  border-radius: 15px;
  overflow: hidden;
}

.hero__video {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.hero__video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  background: linear-gradient(
    to top,
    rgba(56, 109, 218, 0.4) 0%,
    rgba(44, 190, 249, 0.2) 100%
  );
  pointer-events: none;
}

.video-welcome {
  background: var(--color-background-highlight);
}

.video-feature-title {
  text-align: left;
  font-size: 1.5rem;
  font-weight: bold;
}

.video-feature-list-item {
  font-size: 1.4rem;
  background: var(--color-background-highlight);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: var(--border-radius-main);
  font-weight: bold;
  line-height: 1;
}

.video-feature-list-item::before {
  content: '•';
  margin-right: 5px;
}

.video-feature-text {
  font-size: 1.3rem;
  text-align: left;
}
</style>
